import React from "react";
import { Box, Button, Modal, Typography } from "@mui/material";

import { useApp } from "../contexts/app";
import { Player } from "../types/game";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

export const GameFinished = () => {
  const {
    state: {
      onGoingGame,
      displayGameResults,
      game: { winner, onlineGameId, localPlayerId },
    },
    dispatch,
  } = useApp();

  const getResultText = (winner: Player | null): string => {
    if (!winner) {
      return "No winner, it's a draw!";
    }
    if (onlineGameId && localPlayerId !== null) {
      return localPlayerId === winner.id ? "You win!" : "Looser...";
    } else {
      return `${
        winner.name[0].toUpperCase() + winner.name.substring(1)
      } wins the game !`;
    }
  };

  return (
    <Modal
      open={onGoingGame && displayGameResults}
      // onClose={() => dispatch({ type: "FINISH_GAME" })}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={style}
        className="d-flex flex-column justify-content-center align-items-center p-5"
      >
        <Typography id="modal-modal-title" variant="h6" component="h2">
          {getResultText(winner)}
        </Typography>
        <Button
          className="mt-4"
          onClick={() => {
            dispatch({ type: "FINISH_GAME" });
          }}
          variant="contained"
        >
          Continue
        </Button>
      </Box>
    </Modal>
  );
};
